import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AdminProvider } from "@/contexts/AdminContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import SectorsPage from "@/pages/SectorsPage";
import TeamPage from "@/pages/TeamPage";
import InsightsPage from "@/pages/InsightsPage";
import InsightDetailPage from "@/pages/InsightDetailPage";
import InsightPreviewPage from "@/pages/InsightPreviewPage";
import InternationalPage from "@/pages/InternationalPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminSettings from "@/admin/AdminSettings";
import AdminAddresses from "@/admin/AdminAddresses";
import AdminTeam from "@/admin/AdminTeam";
import AdminInsights from "@/admin/AdminInsights";
import AdminInsightEdit from "@/admin/AdminInsightEdit";
import AdminPages from "@/admin/AdminPages";
import AdminPageEdit from "@/admin/AdminPageEdit";
import AdminContacts from "@/admin/AdminContacts";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Remove Emergent badge
function RemoveBadge() {
  useEffect(() => {
    const remove = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    remove();
    const obs = new MutationObserver(remove);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AdminProvider>
        <ScrollToTop />
        <RemoveBadge />
        <div className="flex flex-col min-h-screen">
          <Routes>
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="addresses" element={<AdminAddresses />} />
              <Route path="team" element={<AdminTeam />} />
              <Route path="insights" element={<AdminInsights />} />
              <Route path="insights/:id" element={<AdminInsightEdit />} />
              <Route path="pages" element={<AdminPages />} />
              <Route path="pages/:slug" element={<AdminPageEdit />} />
              <Route path="contacts" element={<AdminContacts />} />
            </Route>
            {/* Public Routes */}
            <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><ServicesPage /></PublicLayout>} />
            <Route path="/sectors" element={<PublicLayout><SectorsPage /></PublicLayout>} />
            <Route path="/team" element={<PublicLayout><TeamPage /></PublicLayout>} />
            <Route path="/insights" element={<PublicLayout><InsightsPage /></PublicLayout>} />
            <Route path="/insights/preview/:id" element={<PublicLayout><InsightPreviewPage /></PublicLayout>} />
            <Route path="/insights/:id" element={<PublicLayout><InsightDetailPage /></PublicLayout>} />
            <Route path="/international" element={<PublicLayout><InternationalPage /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
          </Routes>
        </div>
        <Toaster position="top-right" />
      </AdminProvider>
    </BrowserRouter>
  );
}

export default App;
